// Validation utility functions

// Check if a value is a valid non-empty string
export function isValidString(value) {
    return value !== null && typeof value === 'string' && value.trim() !== '';
  }
  
  // Check if a value is a valid number
  export function isValidNumber(value) {
    return value !== null && !isNaN(value) && value.trim() !== '';
  }
  